angular.module('directives.authentication')
    .directive('phoneinput', ['Authentication', 'configs', phoneFunc])

function phoneFunc(Authentication, configs) {

    return {
        restrict: 'A',
        require: 'ngModel',
        link: fnc
    };

    function fnc($scope, el, attrs, ctrl) {
        ctrl.$validators.integer = function(modelValue, viewValue) {
            if (ctrl.$isEmpty(modelValue)) {
                return true;
            }
            var value = modelValue ? modelValue.substr(0, 2) : '';
            var config = configs.mobile_codes;
            for (var i = 0; i < config.length; ++i) {
                if (config[i].codes.indexOf(value) != -1) {
                    return true;
                }
            }
            return false;
        };

    }
}

module.exports = 'directives.authentication';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authentication/directives/phoneInput.directive.js
 ** module id = 125
 ** module chunks = 1
 **/